// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"126":"711f54ca","787":"8e9ca74d"}[chunkId] + ".chunk.js";
};